import { withRouter } from 'react-router-dom';
import { Component } from 'react';
import PropTypes from 'prop-types';
import { publish, JUTRO_TOPICS } from '@jutro/events';

export class RoutingTracking extends Component {
    componentDidMount() {
        const { location } = this.props;
        const pathname = _.get(location, "pathname");
        const search = _.get(location, "search");
        const state = _.get(location, "state");
        const customContact = _.get(location, 'state.customContact') || _.get(location, 'customContact');
        this.handleChange(pathname, search, state, customContact);
    }

    componentDidUpdate({ location: prevLocation }) {
        const { location } = this.props;
        const pathname = _.get(location, "pathname");
        const search = _.get(location, "search");
        const state = _.get(location, "state");
        const customContact = _.get(location, 'state.customContact') || _.get(location, 'customContact');
        const isDifferentPathname = pathname !== prevLocation.pathname;
        const isDifferentSearch = search !== prevLocation.search;
        const isDifferentState = state !== prevLocation.state;
        if (isDifferentPathname || isDifferentSearch || isDifferentState) {
            this.handleChange(pathname, search, state, customContact);
        }
    }

    handleChange = (pathname, search, state, customContact) => {
        const page = pathname + search;
        const { location } = window;
        publish(JUTRO_TOPICS.ROUTE_CHANGED, {

            page: pathname,
            state: state,
            location: `${location.origin}${page}`,
            customContact: customContact
        });
    }

    render() {
        return null;
    }
}

RoutingTracking.propTypes = {
    location: PropTypes.shape({
        pathname: PropTypes.string,
        search: PropTypes.string,
        state: PropTypes.shape({}),
    }).isRequired,
};

export default withRouter(RoutingTracking);
